const configApiBase = process.env.API_BASE || '/api/v1'
export default configApiBase
